import * as XLSX from "xlsx";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import { formatIDR } from "@/lib/format";
import { toast } from "sonner";

/**
 * Export detailed transactions to Excel or PDF.
 * @param {Object} opts
 * @param {'excel'|'pdf'} opts.format
 * @param {string} opts.title  Sheet/report title
 * @param {string} opts.filename  Base filename without extension
 * @param {Array<{key:string,label:string,type?:'money'|'text'|'number'}>} opts.columns
 * @param {Array<Object>} opts.rows
 * @param {Array<[string, number]>} [opts.totals]  Extra rows appended to summary
 */
export function exportDetail({ format, title, filename, columns, rows, totals = [] }) {
  if (!rows || rows.length === 0) {
    toast.error("Tidak ada data untuk diekspor");
    return;
  }
  if (format === "excel") {
    const wb = XLSX.utils.book_new();
    const header = columns.map((c) => c.label);
    const data = rows.map((r) =>
      columns.map((c) => {
        const v = r[c.key];
        if (c.type === "money" || c.type === "number") return Number(v || 0);
        return v ?? "";
      }),
    );
    const summary = [[title], [], header, ...data];
    if (totals.length) {
      summary.push([]);
      totals.forEach(([label, value]) => summary.push([label, value]));
    }
    const ws = XLSX.utils.aoa_to_sheet(summary);
    XLSX.utils.book_append_sheet(wb, ws, "Detail");
    XLSX.writeFile(wb, `${filename}.xlsx`);
    toast.success("Excel berhasil diunduh");
    return;
  }
  // PDF
  const doc = new jsPDF({ orientation: "landscape" });
  doc.setFontSize(14);
  doc.text(title, 14, 14);
  doc.setFontSize(10);
  doc.text(`Total baris: ${rows.length}`, 14, 20);
  autoTable(doc, {
    startY: 24,
    head: [columns.map((c) => c.label)],
    body: rows.map((r) =>
      columns.map((c) => {
        const v = r[c.key];
        if (c.type === "money") return formatIDR(v);
        return v ?? "";
      }),
    ),
    headStyles: { fillColor: [15, 23, 42] },
    styles: { fontSize: 8, cellPadding: 2 },
    columnStyles: columns.reduce((acc, c, i) => {
      if (c.type === "money" || c.type === "number") acc[i] = { halign: "right" };
      return acc;
    }, {}),
  });
  if (totals.length) {
    autoTable(doc, {
      head: [["Ringkasan", "Nilai"]],
      body: totals.map(([l, v]) => [l, formatIDR(v)]),
      headStyles: { fillColor: [16, 185, 129] },
      styles: { fontSize: 9 },
    });
  }
  doc.save(`${filename}.pdf`);
  toast.success("PDF berhasil diunduh");
}
